// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-46b02e27] .tns-ovh{overflow:visible}", "",{"version":3,"sources":["webpack://./resources/js/components/jobs/JobSlider.vue"],"names":[],"mappings":"AACA,2BACI,gBAAJ","sourcesContent":["\n::v-deep .tns-ovh {\n    overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
